import React, { useContext } from 'react';

import GlobalContext from 'GlobalContext';

import Text from 'components/shared/text';

import './Card.scss';

const Card = ({
  icon,
  children,
  restOfProps,
  headerText = 'example header text',
}) => {
  const { darkMode } = useContext(GlobalContext);

  return (
    <section
      {...restOfProps}
      className={darkMode ? 'dark-card' : 'card'}
    >
      <div className="card-header">
        <div />
        <Text text={headerText} color="#fff" fontSize="32px" margin="0" />
        {icon && icon}
      </div>
      <div className='card-content'>
        {children}
      </div>
    </section>
  );
}

export default Card;
